<template>
    <div v-if="defect">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ defect.formattedDate }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Package:</h2>
                            <p class="mt-1 text-gray-500">{{ defect.packageName }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-3xl font-semibold text-gray-900"
                         v-text="'Defect '+defect.reference"></div>
                    <div class="mb-8 text-gray-500">
                        <span class="font-semibold"
                              v-text="'Reference : '+defect.id"></span> •
                        <span class="font-semibold" v-text="defect.packageReference"></span>
                    </div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Description of Problem</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="defect.descriptionOfProblem"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4" v-if="defect.requiredToMakeGood">Required to Make Good</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-if="defect.requiredToMakeGood" v-text="defect.requiredToMakeGood"></div>
                    <div class="mt-6" v-if="getDayworksFiles().length">
                        <div class="text-xl font-semibold text-gray-900 mt-4 mb-4">Images, Videos and PDFs</div>
                        <ui-input-file-inline name="media[]"
                                              :readonly="true"
                                              :downloadUrl="downloadUrl"
                                              :current-files="getDayworksFiles"></ui-input-file-inline>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {ExternalDefect} from '@models'
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiInputFileInline from "../../../filesystem/inline/UiInputFileInline.vue";

export default {
    components: {UiInputFileInline, UiDropdownItem, UiTextarea, UiDropdown},
    props: {
        id: null | String,
    },
    data() {
        return {
            defect: null,
        }
    },
    computed: {},
    methods: {
        downloadUrl(id) {
            return route('api.v2.external.defect.file.download', {
                'id': this.id,
                'file_id': id
            }) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
        },
        getDayworksFiles() {
            return this.defect.files
        },
    },
    async mounted() {
        if (this.id) {
            this.defect = await ExternalDefect.find(this.id);
        }
    },
}
</script>
